module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/vi-64a66cda803cf0e985eeab05915625d5.jpg";